import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  headerContainer: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  carbonAccountContainer: {
    horizontalAlign: 'space-between',
  },
 
 
 
  shimmerViewMainContainer: {
    marginTop: 30,
    marginBottom: 90,
  },
 
  requiredAttachmentsMessage: {
    paddingTop: 20,
  },
  modalContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    backgroundColor: theme.palette.white,
    width: 1500,
    boxShadow: `-7px 2px 13px rgba(0, 0, 0, 0.10)`,
    height: 900,
  },
  closeButton: {
    color: theme.palette.neutralDark,
    marginLeft: 10,
  },
  header: {
    zIndex: 999,
    position: 'sticky',
    top: 0,
    padding: 20,
    backgroundColor: theme.palette.neutralLighterAlt,
  },
}));
